import { gql } from '@apollo/client';
import { ReplayStop, REPLAY_STOP_FIELDS } from './types';

export interface ReplayRouteBasicInfo {
    dspTaskId: number;
    routeName: string;
    taskDate?: string | null;
    warehouseId?: number | null;
    warehouseName?: string | null;
    areaId?: number | null;
    areaName?: string | null;
    dspId?: number | null;
    driverAccountId?: number | null;
    driverName?: string | null;
    assignedParcels?: number | null;
    stopRange?: string | null; // 如 "1-72"
    status?: string | null;
}

export interface ReplayRouteDetail {
    route: ReplayRouteBasicInfo;
    startPoint?: ReplayStop | null; // key="-1"
    endPoint?: ReplayStop | null; // key="-2"
    stops: ReplayStop[]; // 算法顺序
}

export interface GetReplayRouteDetailResponse {
    getReplayRouteDetail: ReplayRouteDetail | null;
}

export interface GetReplayRouteDetailVariables {
    dspTaskId: number;
}

export const GET_REPLAY_ROUTE_DETAIL = gql`
    query GetReplayRouteDetail($dspTaskId: Long!) {
        getReplayRouteDetail(dspTaskId: $dspTaskId) {
            route {
                dspTaskId
                routeName
                taskDate
                warehouseId
                warehouseName
                areaId
                areaName
                dspId
                driverAccountId
                driverName
                assignedParcels
                stopRange
                status
            }
            startPoint {${REPLAY_STOP_FIELDS}}
            endPoint {${REPLAY_STOP_FIELDS}}
            stops {${REPLAY_STOP_FIELDS}}
        }
    }
`;
